var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center mb-9 space-y-2"},[_c('div',{staticClass:"text-3xl font-bold"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"text-lg font-light"},[_vm._v(_vm._s(_vm.subTitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }